import React from 'react';
import NavigationBar from '../components/NavigationBar/NavigationBar';

export default function NavigationBarApp() {
  // eslint-disable-next-line react/react-in-jsx-scope
  return <NavigationBar />;
}
